import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import AiHubDetailBreadcrumb from "./AiHubDetailBreadcrumb";

export function AiHubDetailLoadingState() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f7f8fa",
      }}
    >
      <CircularProgress size={32} />
    </Box>
  );
}

type AiHubDetailErrorStateProps = Readonly<{
  resultId: string;
  message: string;
  onBack: () => void;
}>;

export function AiHubDetailErrorState({
  resultId,
  message,
  onBack,
}: AiHubDetailErrorStateProps) {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f7f8fa", p: 3 }}>
      <AiHubDetailBreadcrumb
        currentLabel={resultId || "Result"}
        onBack={onBack}
      />
      <Typography sx={{ mt: 2, color: "#CF1322" }}>{message}</Typography>
    </Box>
  );
}
